import company_header from '../../assets/images/header/header-company.png';
import portfolio_header from '../../assets/images/header/header-portfolio.png';
import product_header from '../../assets/images/header/header-product.png';
import rfid_nfc_header from '../../assets/images/header/header-rfid_nfc.png';
import solution_header from '../../assets/images/header/header-solution.png';
import support_header from '../../assets/images/header/header-support.png';
import m_company_header from '../../assets/images/header/m-header-company.png';
import m_portfolio_header from '../../assets/images/header/m-header-portfolio.png';
import m_product_header from '../../assets/images/header/m-header-product.png';
import m_rfid_nfc_header from '../../assets/images/header/m-header-rfid_nfc.png';
import m_solution_header from '../../assets/images/header/m-header-solution.png';
import m_support_header from '../../assets/images/header/m-header-support.png';

const HeaderData = {
    company: {
        image: company_header,
        m_image: m_company_header,
        title: "Company",
        descript: "끊임 없는 변화와 혁신을 추구하는 엠포플러스 입니다.",
    },
    portfolio: {
        image: portfolio_header,
        m_image: m_portfolio_header,
        title: "PORTFOLIO",
        descript: "엠포플러스㈜ 의 납품현황을 확인하실 수 있습니다.",
    },
    product: {
        image: product_header,
        m_image: m_product_header,
        title: "PRODUCT",
        descript: "다양한 기업의 비즈니스 니즈를 해결 하기 위한 제품을 소개합니다.",
    },
    rfid_nfc: {
        image: rfid_nfc_header,
        m_image: m_rfid_nfc_header,
        title: "RFID / NFC",
        descript: "RFID / NFC 관련 정보를 제공합니다.",
    },
    solution: {
        image: solution_header,
        m_image: m_solution_header,
        title: "SOLUTION",
        descript: "사용자의 편의를 최우선으로 고려한 프리미엄 솔루션을 제공합니다.",
    },
    support: {
        image: support_header,
        m_image: m_support_header,
        title: "SUPPORT",
        descript: "저희 엠포플러스㈜와 소통할 수 있는 서비스 공간 입니다.",
    },
};

export default HeaderData;